import { createStore } from "vuex";
import dispatchActionForAllModules from "../utils/dispatch-action-for-all-modules";

import modules from "../state/modules";

export default createStore({
  modules,
  state() {
    return {
      balance: 0,
      isLogin: false,
      chainId: "",
      ethereumChainId: "",
      headerMessage: {
        show: false,
        message: "",
      },
      jointAddress: null,
      // ZM-13
      snackbarVisible: false,
      snackbarMessage: "",
    };
  },
  getters: {
    jointAddress(state) {
      return state.jointAddress;
    },
  },
  mutations: {
    setBalance(state, data) {
      state.balance = data;
    },
    setLogin(state, data) {
      state.isLogin = data;
    },
    setChainId(state, data) {
      state.chainId = data;
    },
    setHeaderMessage(state, data) {
      state.headerMessage = data;
    },
    setEthereumChainId(state, data) {
      state.ethereumChainId = data;
    },
    setJointAddress(state, address) {
      state.jointAddress = address;
    },
    // ZM-13
    SHOW_SNACKBAR(state, message) {
      state.snackbarMessage = message;
      state.snackbarVisible = true;
    },
    HIDE_SNACKBAR(state) {
      state.snackbarVisible = false;
    },
  },
  actions: {
    changeLogin(context, data) {
      context.commit("setLogin", data);
    },
    updateJointAddress({ commit }, address) {
      commit("setJointAddress", address);
    },
    // ZM-13
    triggerSnackbar({ commit }, message) {
      commit("SHOW_SNACKBAR", message);
    },
    hideSnackbar({ commit }) {
      commit("HIDE_SNACKBAR");
    },
  },
  // modules: {},
});

dispatchActionForAllModules("init");
